import i18next from 'i18next'

export const DEFAULT_ERROR_TITLE = 'Error'
export const DEFAULT_WARNING_TITLE = 'Warning'
export const DEFAULT_SUCCESS_TITLE = 'Success'

export const DEFAULT_ERROR_CONTENT = 'An error occurred, please try again'

export const FAVORITE_ACTIVITY_REMOVED = 'Activity removed from favorites'
export const FAVORITE_ACTIVITY_ADDED = 'Activity added to favorites'
export const ACTIVITY_FINISHED = "You finished today's activity"
export const PREVIOUS_ACTIVITY_FINISHED = 'You finished previous activity'
export const ACTIVITY_COMMITED = "You committed to today's activity"
export const PROFILE_SAVED = 'Successfully saved your profile'
export const SUBSCRIBED_TO_PROTRACK = name => i18next.t('user:You subscribed to', { name })
export const PROTRACK_HAS_ACTIVE_USERS = 'ProTrack has active users'
export const FEEDBACK_SENT = 'Thank you for your feedback'
export const WELCOME_EMAIL_SAVED = 'Welcome settings has been saved'
export const USERS_INVITED = 'Users successfully invited'
export const SCHEDULED_USERS_INVITES = 'Users will be invited'
export const ORG_VALUE_ADDED = 'New value successfully added'
export const ORG_VALUE_UPDATED = 'Value successfully updated'
export const PROTRACK_FINISHED = protrackName => `You finished ${protrackName}`
export const ORG_INACTIVE_NOTIFICATION_DELETE_SUCCESS = 'Notification removed'
export const ORG_INACTIVE_NOTIFICATION_CREATE_SUCCESS = 'Notification created'
export const ORG_INACTIVE_NOTIFICATION_UPDATE_SUCCESS = 'Notification updated'
export const HOLIDAYS_UPDATED = 'Holidays updated'
export const CHECK_INTERNET = 'Please check your internet connection and try again'
export const GALLERY_IMAGE_DELETE_SUCCESS = 'Image deleted'
export const ALREADY_DID = 'You already did it!'
export const ALREADY_COMMITED = 'You have already committed to this activity'
export const ALREADY_SELECTED_NEW_PROTRACK = 'You have already used this link to select your ProTrack'
export const ALREADY_USED_LOGIN_LINK = 'You have already used this link to login'
export const INVALID_TOKEN = 'Invalid token. Please try login again'
